/* =====================================================================
   CASA · MOBILE SHOP LINKS IN THE SORT DROPDOWN  (15 Sep 2026)
   ---------------------------------------------------------------------
   At 760px and below the hover Shop menu is hidden (.top-menu, CSS
   "@media (max-width: 760px)") and the drawer only offers Shop All and
   New In, so a phone had no way to reach Handbags or Accessories. This
   appends a "Shop" group (All Handbags, Accessories, New In) to the
   Shop and New In sort dropdowns, ON PHONES ONLY. No Jewelry, on purpose.

   ⚠️ DESKTOP MUST NOT CHANGE — Erich's rule for this fix. So this module:
     - edits no existing markup, CSS or function and wraps nothing on window;
     - inserts its <optgroup> only while MQ matches, and removes it and its
       listeners the moment MQ stops matching;
     - APPENDS after the sort options. wireSort() and the i18n tagger both
       map sort options by POSITION (0–4) — anything inserted before them
       would shift sorting and translations.
   MQ must equal the .top-menu breakpoint. If that CSS moves, move MQ with
   it; scripts/verify-shop-filters.cjs fails when the two differ.
   ===================================================================== */
(function casaMobileShopLinks(){
  if (!window.matchMedia) return;
  var MQ = '(max-width: 760px)';
  var mq = window.matchMedia(MQ);
  var SELECTORS = ['#view-shop .sort-select', '#view-newin .sort-select'];
  var ITEMS = [
    { key: 'footer.allHandbags', text: 'All Handbags', go: function(){ window.navigateShopByCategory('Handbags'); } },
    { key: 'cat.accessories',    text: 'Accessories',  go: function(){ window.navigateShopByCategory('Accessories'); } },
    // Same call the desktop menu's data-view="newin" link makes.
    // Label matches the drawer link and the page title (Erich, 23 Sep 2026). The site
    // never translates "New In", so every language carries it as written.
    { key: 'nav.newIn',          text: 'New In',       go: function(){ window.switchView('newin'); } }
  ];
  var attached = false;
  var last = [];   // per select: the sort option showing before the picker opened

  // I18N / currentLang are top-level bindings in an earlier <script>; guard
  // them so a future refactor can only cost translations, not the feature.
  function tr(key, fallback){
    try {
      var lang = (typeof currentLang !== 'undefined' && currentLang) || 'en';
      return (I18N[lang] && I18N[lang][key]) || (I18N.en && I18N.en[key]) || fallback;
    } catch(e){ return fallback; }
  }
  function selects(){
    return SELECTORS.map(function(s){ return document.querySelector(s); });
  }
  function isItem(opt){ return !!(opt && opt.hasAttribute('data-casa-mnav-item')); }

  function label(){
    document.querySelectorAll('optgroup[data-casa-mnav]').forEach(function(g){
      g.label = tr('nav.shop', 'Shop');
      g.querySelectorAll('option[data-casa-mnav-item]').forEach(function(o){
        o.textContent = tr(o.getAttribute('data-i18n'), ITEMS[+o.getAttribute('data-casa-mnav-item')].text);
      });
    });
  }

  // Capture on document runs before the select's own onchange (wireSort), and
  // stopping here means that handler never sees a Shop choice — otherwise it
  // would store "casa-mnav-1" as the sort and re-render the grid with it.
  function onChange(e){
    var i = selects().indexOf(e.target);
    if (i < 0) return;
    var sel = e.target, opt = sel.options[sel.selectedIndex];
    if (!isItem(opt)) { last[i] = sel.selectedIndex; return; }
    e.stopImmediatePropagation();
    e.stopPropagation();
    sel.selectedIndex = last[i] >= 0 ? last[i] : 0;
    var item = ITEMS[+opt.getAttribute('data-casa-mnav-item')];
    try { item.go(); } catch(err){ console.error('Mobile shop link failed:', err); }
  }
  // _shopReset() sets the sort value without firing change, so re-read the
  // real selection each time the picker is opened rather than trusting `last`.
  function remember(e){
    var i = selects().indexOf(e.target);
    if (i >= 0 && !isItem(e.target.options[e.target.selectedIndex])) last[i] = e.target.selectedIndex;
  }

  function attach(){
    if (attached) return;
    selects().forEach(function(sel, i){
      if (!sel || sel.querySelector('optgroup[data-casa-mnav]')) return;
      last[i] = sel.selectedIndex;
      var g = document.createElement('optgroup');
      g.setAttribute('data-casa-mnav', '');
      ITEMS.forEach(function(item, n){
        var o = document.createElement('option');
        o.value = 'casa-mnav-' + n;
        o.setAttribute('data-casa-mnav-item', String(n));
        o.setAttribute('data-i18n', item.key);   // the site's own language pass keeps it translated
        g.appendChild(o);
      });
      sel.appendChild(g);
    });
    label();
    document.addEventListener('change', onChange, true);
    document.addEventListener('pointerdown', remember, true);
    document.addEventListener('focusin', remember, true);
    attached = true;
  }
  function detach(){
    if (!attached) return;
    document.removeEventListener('change', onChange, true);
    document.removeEventListener('pointerdown', remember, true);
    document.removeEventListener('focusin', remember, true);
    selects().forEach(function(sel, i){
      if (!sel) return;
      if (isItem(sel.options[sel.selectedIndex])) sel.selectedIndex = last[i] >= 0 ? last[i] : 0;
      sel.querySelectorAll('optgroup[data-casa-mnav]').forEach(function(g){ g.remove(); });
    });
    attached = false;
  }
  function sync(){ if (mq.matches) attach(); else detach(); }

  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
  // setLanguage() stamps <html lang>; an optgroup label is an attribute the
  // site's data-i18n pass cannot reach, so relabel when that changes.
  try {
    new MutationObserver(function(){ if (attached) label(); })
      .observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  } catch(e){}
})();
